// src/components/Layout/Sidebar.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Sidebar = ({ isOpen, toggle }) => {
  const location = useLocation();
  const links = [
    { label: 'Home', short: 'H', href: '/', icon: '/images/home.png' },
    { label: 'Create', short: 'C', href: '/create', icon: '/images/create.png' },
    { label: 'Profile', short: 'P', href: '/profile', icon: '/images/profile.png' },
    { label: 'Leaderboard', short: 'L', href: '/leaderboard', icon: '/images/leaderboard.png' },
    { label: 'Browse', short: 'B', href: '/browse', icon: '/images/browse.png' },
    { label: 'Fame', short: 'F', href: '/fame', icon: '/images/halloffame.png' },
  ];

  const isMobile = window.innerWidth <= 768;

  if (isMobile) {
    return (
      <div style={styles.mobileNav}>
        {links.map((link) => (
          <Link key={link.href} to={link.href} style={styles.mobileLink}>
            <img src={link.icon} alt={link.label} style={styles.iconOnly} />
          </Link>
        ))}
      </div>
    );
  }

  return (
    <div
      style={{
        ...styles.sidebar,
        width: isOpen ? '200px' : '60px',
        transform: 'translateX(0)',
      }}
    >
      <div style={styles.header}>
        <span style={styles.logo}>{isOpen ? 'DeepMeme' : 'D'}</span>
        <button onClick={toggle} style={styles.toggleBtn}>
          {isOpen ? '⮜' : '⮞'}
        </button>
      </div>
      <nav style={styles.nav}>
        {links.map((link) => (
          <Link key={link.href} to={link.href} style={{
            ...styles.link,
            color: location.pathname === link.href ? '#FFA800' : '#FAFF00',
          }}>
            <div style={styles.linkRow}>
              <img src={link.icon} alt={link.label} style={styles.icon} />
              {isOpen && <span style={{ marginLeft: '0.5rem' }}>{link.label}</span>}
            </div>
          </Link>
        ))}
      </nav>
    </div>
  );
};

const styles = {
  sidebar: {
    backgroundColor: '#1e1e1e',
    color: '#fff',
    padding: '1rem 0.5rem',
    transition: 'width 0.3s ease',
    minHeight: '100vh',
    position: 'relative',
    zIndex: 10,
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '2rem',
    fontSize: '1.5rem',
    fontFamily: 'VT323',
    padding: '0 0.5rem',
  },
  logo: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  toggleBtn: {
    background: 'none',
    border: 'none',
    color: '#fff',
    fontSize: '1.2rem',
    cursor: 'pointer',
  },
  nav: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '0 0.5rem',
  },
  link: {
    textDecoration: 'none',
    fontSize: '1.2rem',
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
  },
  linkRow: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    width: '20px',
    height: '20px',
  },
  mobileNav: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'space-around',
    backgroundColor: '#1e1e1e',
    padding: '0.75rem 0',
    zIndex: 100,
  },
  mobileLink: {
    textDecoration: 'none',
  },
  iconOnly: {
    width: '24px',
    height: '24px',
  },
};

export default Sidebar;